<template>
  <div class="pt-2">
    <div class="title text-dark mb-1" :style="{color: $themes.primary}">
      {{$t('dashboard.tabs.bankDetails.detailsFields')}}
    </div>
    <div class="row">
      <div class="flex xs12 md6">
        <va-input
          :label="$t('dashboard.tabs.bankDetails.bankName')"
          :readonly = "true"
          v-model="form.bankName"
        />
        <va-input
          :label="$t('dashboard.tabs.bankDetails.accountType')"
          :readonly = "true"
          v-model="form.accountName"
        />
        <va-input
          :label="$t('dashboard.tabs.bankDetails.sortCode')"
          :readonly = "true"
          v-model="form.sortCode"
        />
      </div>
      <div class="flex xs12 md6">
        <va-input
          :label="$t('dashboard.tabs.bankDetails.accountNumber')"
          :readonly = "true"
          v-model="form.accountNumber"
        />
        <!-- <va-input
          :label="$t('dashboard.tabs.bankDetails.notes')"
          v-model="form.notes"
        /> -->
      </div>
    </div>
    <!-- <div class="row justify--center">
      <va-button @click="sendDetails">
        {{ $t('dashboard.tabs.bankDetails.sendDetails') }}
      </va-button>
    </div> -->
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'bank-details-tab',
  data () {
    return {
      form: {
        bankName: '',
        accountName: '',
        sortCode: '',
        accountNumber: '',
        notes: '',
      },
      userData: {

      },
      token: JSON.parse(localStorage.getItem('Token')),
      fosaDetails: {

      },
    }
  },
  methods: {
    sendDetails () {
      this.showToast('Saved!')
    },
    async GetFosaNumberFromIdno () {
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      const posdata = {
        user_id: this.userData.user_id,
        id_no: this.userData.id_number,
      }

      await axios.post(`${self.$apiUrl}getfosanumberfromidno`, posdata, config)
        .then(function (res) {
          localStorage.setItem('UserMianFosa', JSON.stringify(res.data.acc_details))
          res = res.data.acc_details
          self.form.accountName = res.accname
          self.form.bankName = res.holder_name
          self.form.accountNumber = res.accno
          self.form.sortCode = res.paybill_code + self.userData.member_number
        })
        .catch(function (error) {
          console.log(error)
        })
    },
  },
  created () {
    this.userData = JSON.parse(localStorage.getItem('LoggedUser'))
    this.fosaDetails = JSON.parse(localStorage.getItem('UserMianFosa'))
    if (!this.fosaDetails) {
      this.GetFosaNumberFromIdno()
    } else {
      this.form.accountName = this.fosaDetails.accname
      this.form.bankName = this.fosaDetails.holder_name
      this.form.accountNumber = this.fosaDetails.accno
      this.form.sortCode = this.fosaDetails.paybill_code + this.userData.member_number
    }
  },
}
</script>
